import { memo } from 'react'
import { useTheme } from 'styled-components'

import { Hexagon } from '@components/Hexagon'
import { useIsTabletS } from '@hooks/use-media-query'

import {
  BlockWrapper,
  ContentWrapper,
  Header,
  HexagonWrapper,
  Subtitle,
  TextWrapper,
  Button,
} from './styles'

function GraySectionComponent({
  id,
  children,
  title = '',
  subtitle = '',
  buttonLabel = '',
  textWidth = 'fit-content',
  textTransform = 'initial',
  ...props
}) {
  const { newSpaces } = useTheme()
  const isTabletS = useIsTabletS()

  return (
    <BlockWrapper className="wrapper">
      <ContentWrapper className="gray-section-wrapper">
        <HexagonWrapper className="hexagon-wrapper">
          <Hexagon icon={children} />
        </HexagonWrapper>
        <TextWrapper textWidth={textWidth} className="text-wrapper">
          <Header textTransform={textTransform} as="h2">
            {title}
          </Header>
          {subtitle && (
            <Subtitle as="h3" className="subtitle">
              {subtitle}
            </Subtitle>
          )}
          <Button
            id={id}
            className="section-button"
            label={buttonLabel}
            backgroundColor="secondary"
            backgroundColorOnHover="secondary"
            marginTop={`${isTabletS ? newSpaces.lg : newSpaces.sm}px`}
            {...props}
          />
        </TextWrapper>
      </ContentWrapper>
    </BlockWrapper>
  )
}

export const GraySection = memo(GraySectionComponent)
